import { useEffect } from 'react';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';

/**
 * Shows a success toast when token-based login succeeds (e.g. LMS redirect).
 * Must be rendered inside ToastProvider so useToast() works.
 */
const TokenLoginToastHandler = () => {
	const toast = useToast();
	const { tokenLoginSuccessMessage, setTokenLoginSuccessMessage } = useUserContext();

	useEffect(() => {
		if (tokenLoginSuccessMessage) {
			toast({ title: tokenLoginSuccessMessage, type: 'success' });
			setTokenLoginSuccessMessage(null);
		}
	}, [tokenLoginSuccessMessage, toast, setTokenLoginSuccessMessage]);

	return null;
};

export default TokenLoginToastHandler;
